import { render } from "./BaseFileItem.vue?vue&type=template&id=63a94412"
import script from "./BaseFileItem.vue?vue&type=script&lang=js"
export * from "./BaseFileItem.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "63a94412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63a94412', script)) {
    api.reload('63a94412', script)
  }
  
  module.hot.accept("./BaseFileItem.vue?vue&type=template&id=63a94412", () => {
    api.rerender('63a94412', render)
  })

}

script.__file = "src/ui/BaseFileItem.vue"

export default script